var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_vm._l((_vm.recordList),function(item,index){return _c('record-item',{key:index,attrs:{"item":item}})}),(!_vm.recordList.length)?_c('empty',{staticClass:"empty-box",attrs:{"desc":"无反馈记录","img":"Empty"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }